import { useMutation, useQuery, useQueryClient } from 'react-query';
import axios from 'axios';
import { PinLockState, PinLockUpdate } from '../models/pinLock';

const apiUrl = process.env.REACT_APP_BASIX_API || '';

const getPinLock = async (): Promise<PinLockState> => {
  const { data } = await axios.get(`${apiUrl}settings/PinLock`);
  return data;
};

// Personal PIN-code idle lock (item 106). The lock state drives the idle provider;
// the verify mutation resolves on 200 and REJECTS on a wrong PIN (400) so the lock
// screen can count misses toward the full-logout fallback.
const usePinLock = () => {
  const queryClient = useQueryClient();
  const query = useQuery('pinLock', getPinLock);

  const update = useMutation(
    (payload: PinLockUpdate) => axios.post(`${apiUrl}settings/PinLock`, payload),
    { onSuccess: () => queryClient.invalidateQueries('pinLock') },
  );

  const verify = useMutation(
    (pin: string) => axios.post(`${apiUrl}settings/PinLock/Verify`, { pin }),
  );

  return {
    ...query,
    pinLock: query.data,
    tryUpdate: update.mutateAsync,
    isSaving: update.isLoading,
    tryVerify: verify.mutateAsync,
    isVerifying: verify.isLoading,
  };
};

export default usePinLock;
